import { useContext } from 'react';
import { SelfContext } from '.';

export const getVaraiantBySelfType = (type: SelfType) => ({
  'NORMAL': 'nurture',
  'SPORT': 'sport',
  'CLINIC': 'health',
  'TRANSPORT': 'transport',
  'undefined': 'unknown',
}[String(type)]) as ComponentVariant;

export const getSelfTypeByVaraiant = (variant: ComponentVariant) => ({
  'nurture': 'NORMAL',
  'sport': 'SPORT',
  'health': 'CLINIC',
  'transport': 'TRANSPORT',
  'undefined': 'Unknown'
}[String(variant)]) as string;

export const useSelfContext = () => useContext(SelfContext);
